import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { RewardsPreferenceFacade } from '@features/rewards-preference/facades/rewards-preference/rewards-preference.facade';
import { AuthFacade } from '@rd/core/auth/store/facades/auth.facade';
import { UnleashFacade } from '@rd/core/facades/unleash-facade/unleash-facade.ts';
import { PopupPromptDialogComponent } from '@rd/popup/components/prompt-dialog/prompt-dialog.component';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class BenefitPromptGuard implements CanActivate {
  constructor(
    private rewardsPreferenceFacade: RewardsPreferenceFacade,
    private dialogService: DialogService,
    private router: Router,
    private authFacade: AuthFacade,
    private unleashFacade: UnleashFacade,
  ) {}

  isLoggedIn$: Observable<boolean> = this.authFacade.isLoggedIn$;

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    // Wait for user to not be null
    return this.isLoggedIn$.pipe(
      switchMap(
        // Wait for rewards preference call to be loaded
        (loggedIn) => {
          if (loggedIn) {
            return this.rewardsPreferenceFacade.getRewardsPreferenceSuccess$.pipe(
              filter((a) => Boolean(a)),
            );
          }
          return of(true);
        },
      ),
      switchMap(() =>
        combineLatest([
          this.rewardsPreferenceFacade.rewardsPreference$,
          this.isLoggedIn$,
          this.unleashFacade.isUnleashClientReady$,
        ]),
      ),
      tap(([rewardsPreference, isloggedIn]) => {
        if (isloggedIn && !rewardsPreference) {
          if (route.url.length !== 0) {
            // If trying to visit a route that is not home page
            this.router.navigateByUrl('/');
          }
          this.dialogService.open(PopupPromptDialogComponent, {
            data: {
              title: 'wl.star.benefit.prompt.welcome_reward_title',
              body: 'wl.star.benefit.prompt.welcome_reward_body',
              primaryButtonLabel:
                'wl.star.benefit.prompt.welcome_reward_button',
              primaryButtonClick: () => {
                this.router.navigate(['/select-carrier/loyalty-programs']);
              },
            },
            id: 'star-rewards-preference-guard',
            screenMode: 'center-md',
            keepModalOnOverlayClick: true, // disable for now for testing
          });
        }
      }),
      map(() => true), // disable for now for testing
    );
  }
}
